import { render, staticRenderFns } from "./DepartmentSubjectSwitcher.vue?vue&type=template&id=7ffc1bc7"
import script from "./DepartmentSubjectSwitcher.vue?vue&type=script&lang=js"
export * from "./DepartmentSubjectSwitcher.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSubjectSwitcher.vue?vue&type=style&index=0&id=7ffc1bc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports